<template>
    <div>
        <page-header :title="$t('notifications.title')" />
        <ad-leaderboard />
        <div v-if="!isLoading">
            <div v-if="notifications.length">
                <div
                    class="notification-wrapper w-100 ion-text-start ion-padding"
                    :key="notification.id"
                    v-for="notification in notifications"
                >
                    <div class="notification" @click="redirectTo(notification)">
                        <div>
                            <ion-text>
                                <b>{{ lang == 'en' ? notification.data.titleEN : notification.data.titleAR }}</b>
                            </ion-text>
                        </div>
                        <div>
                            <ion-text>{{ lang == 'en' ? notification.data.messageEN : notification.data.messageAR }}</ion-text>
                        </div>
                    </div>
                </div>
                <ion-infinite-scroll @ionInfinite="loadMore" threshold="10%" position="bottom">
                    <ion-infinite-scroll-content></ion-infinite-scroll-content>
                </ion-infinite-scroll>
            </div>
            <div v-else>{{ $t('notifications.empty') }}</div>
        </div>
        <div v-else>
            <ion-spinner color="primary"></ion-spinner>
        </div>
    </div>
</template>

<script>
import PageHeader from '@/components/PageHeader'
import AxiosController from '@/controllers/AxiosController'
import { mapGetters } from 'vuex'
import AdLeaderboard from '@/components/AdLeaderboard'

export default {
    name: 'Notifications',
    components: { PageHeader, AdLeaderboard },
    computed: mapGetters(['lang']),
    data() {
        return {
            notifications: [],
            currentPage: 1,
            lastPage: 0,
            isLoading: true
        }
    },
    mounted() {
        AxiosController.get('/notifications').then(res => {
            const { last_page, data } = res.data
            this.notifications = data
            this.lastPage = last_page
            this.isLoading = false
            this.$store.dispatch('resetNotificationsCount')
        })
    },
    methods: {
        redirectTo: function(notification) {
            if (notification.data.url) {
                this.$router.push('/' + notification.data.url)
            }
        },
        loadMore(event) {
            if (this.currentPage >= this.lastPage) {
                event.target.complete()
                return
            }
            this.loadMoreNotifications()
            event.target.complete()
        },
        loadMoreNotifications: function() {
            this.currentPage = this.currentPage + 1
            const params = {
                page: this.currentPage
            }
            AxiosController.get('/notifications', { params }).then(res => {
                const { last_page, data } = res.data
                this.lastPage = last_page
                this.notifications.push(...data)
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.notification-wrapper {
    border-bottom: 1px solid #000000;

    .notification {
        cursor: pointer;
    }
}

@media (min-width: 768px) {
    ion-text {
        font-size: 20px;
    }
}
</style>
